import React, { PureComponent } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { Skeleton } from 'antd';

// const data = [
//   {
//     name: 'Page A', uv: 4000, pv: 2400, amt: 2400,
//   },
//   {
//     name: 'Page B', uv: 3000, pv: 1398, amt: 2210,
//   },
//   {
//     name: 'Page C', uv: 2000, pv: 9800, amt: 2290,
//   },
//   {
//     name: 'Page D', uv: 2780, pv: 3908, amt: 2000,
//   },
//   {
//     name: 'Page E', uv: 1890, pv: 4800, amt: 2181,
//   },
//   {
//     name: 'Page F', uv: 1890, pv: 4800, amt: 2181,
//   },
//   {
//     name: 'Page G', uv: 3490, pv: 4300, amt: 2100,
//   },
// ];

class DashboardLineChart extends PureComponent {
  static jsfiddleUrl = 'https://jsfiddle.net/alidingling/xqjtetw0/';

  constructor(props) {
    super(props)
    this.state={}

    // console.log("line constructed for line")
  };


  render() {
    let item = this.props.data || {};
    let config = item.widget_config || {};
    let data = item.widget_data || [];
    let x_data = config.x || {};
    let y_data = config.y || [];

    return (
      <div style={{
        width: '100%', height: 300,
      }}>
        <ResponsiveContainer>
          <LineChart
            data={data}
            margin={{
              top: 5, right: 15, left: 15, bottom: 5,
            }}>
            {/* <CartesianGrid strokeDasharray="3 3" /> */}

            <XAxis dataKey={x_data.key} />
            {}
            <YAxis />
            <Tooltip />
            <Legend />
            {
              y_data.map((item) => {
                return <Line name={item.title||item.key} type="monotone" dataKey={item.key} />
              })
            }
            {/* <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
        <Line type="monotone" dataKey="uv" stroke="#82ca9d" /> */}
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default DashboardLineChart